import { TemplateRef } from '@angular/core';
import { ActionItem } from '../action-menu/action-links.model';

/**
 * Primary and Secondary action button types has next required attributes: key, click or url
 * Cog action type has no required field, it get columns from cpq-datatable input, key can be empty string
 * and if this button have to be displayed it must be in ActionButton array
 * MenuButton action type has next required fields: key, array of actions
 */
export class ActionButton {
    public key: string;
    public click?: () => void;
    public url?: string;
    public actions?: Array<ActionItem>;
    public type: ActionButtonType;
    public hide?: () => boolean;
    public disable?: () => boolean;
    public visible?: (row: any) => boolean;
    public customTemplate?: any;
    public position?: ActionButtonPosition = ActionButtonPosition.Left;
    public id?: string;
}

export class DisabledActionButton extends ActionButton {
    public isDisabled?: boolean;
    public isHidden?: boolean;
}

export enum ActionButtonType {
    Primary = 1,
    Secondary,
    MenuButtonPrimary,
    MenuButtonSecondary,
    Custom,
    MenuButton
}

export enum ActionButtonPosition {
    Left,
    Right
}
